module.exports = __webpack_public_path__ + "img/micropointTopBg.21e0d574.png";